/**
 * Generated by orval v7.0.1 🍺
 * Do not edit manually.
 * API V5
 * OpenAPI spec version: v5
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GetApiV5FilesIdNamingSuggestions200,
  GetApiV5FilesIdNamingSuggestions404,
  GetApiV5FilesIdTagSuggestions200,
  GetApiV5FilesIdTagSuggestions404,
  GetApiV5FilesPendingReview200,
  GetApiV5FilesPreferredFormat200,
  GetApiV5FilesPreferredFormat404,
  PostApiV5FilesPreferredFormat200,
  PostApiV5FilesPreferredFormatBody,
  PutApiV5FilesIdMarkAsReviewed200,
  PutApiV5FilesIdMarkAsReviewed404,
  PutApiV5FilesIdRename200,
  PutApiV5FilesIdRename404,
  PutApiV5FilesIdRenameBody,
  PutApiV5FilesIdUpdateTags200,
  PutApiV5FilesIdUpdateTags400,
  PutApiV5FilesIdUpdateTags404,
  PutApiV5FilesIdUpdateTagsBody
} from '.././schemas'
import postApiV5FilesPreferredFormatMutator from '../../configOrvalAPIV5';
import type { ErrorType as PostApiV5FilesPreferredFormatErrorType } from '../../configOrvalAPIV5';
import getApiV5FilesPreferredFormatMutator from '../../configOrvalAPIV5';
import type { ErrorType as GetApiV5FilesPreferredFormatErrorType } from '../../configOrvalAPIV5';
import getApiV5FilesIdNamingSuggestionsMutator from '../../configOrvalAPIV5';
import type { ErrorType as GetApiV5FilesIdNamingSuggestionsErrorType } from '../../configOrvalAPIV5';
import getApiV5FilesIdTagSuggestionsMutator from '../../configOrvalAPIV5';
import type { ErrorType as GetApiV5FilesIdTagSuggestionsErrorType } from '../../configOrvalAPIV5';
import putApiV5FilesIdRenameMutator from '../../configOrvalAPIV5';
import type { ErrorType as PutApiV5FilesIdRenameErrorType } from '../../configOrvalAPIV5';
import putApiV5FilesIdMarkAsReviewedMutator from '../../configOrvalAPIV5';
import type { ErrorType as PutApiV5FilesIdMarkAsReviewedErrorType } from '../../configOrvalAPIV5';
import getApiV5FilesPendingReviewMutator from '../../configOrvalAPIV5';
import type { ErrorType as GetApiV5FilesPendingReviewErrorType } from '../../configOrvalAPIV5';
import putApiV5FilesIdUpdateTagsMutator from '../../configOrvalAPIV5';
import type { ErrorType as PutApiV5FilesIdUpdateTagsErrorType } from '../../configOrvalAPIV5';



/**
 * Saves the preferred file naming format for the current CPA firm
 * @summary Save preferred file format for CPA
 */
export const postApiV5FilesPreferredFormat = (
    postApiV5FilesPreferredFormatBody: PostApiV5FilesPreferredFormatBody,
 ) => {
      
      
      return postApiV5FilesPreferredFormatMutator<PostApiV5FilesPreferredFormat200>(
      {url: `/api/v5/files/preferred_format`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiV5FilesPreferredFormatBody
    },
      );
    }
  


export const getPostApiV5FilesPreferredFormatMutationOptions = <TError = PostApiV5FilesPreferredFormatErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5FilesPreferredFormat>>, TError,{data: PostApiV5FilesPreferredFormatBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV5FilesPreferredFormat>>, TError,{data: PostApiV5FilesPreferredFormatBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV5FilesPreferredFormat>>, {data: PostApiV5FilesPreferredFormatBody}> = (props) => {
          const {data} = props ?? {};

          return  postApiV5FilesPreferredFormat(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV5FilesPreferredFormatMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV5FilesPreferredFormat>>>
    export type PostApiV5FilesPreferredFormatMutationBody = PostApiV5FilesPreferredFormatBody
    export type PostApiV5FilesPreferredFormatMutationError = PostApiV5FilesPreferredFormatErrorType<unknown>

    /**
 * @summary Save preferred file format for CPA
 */
export const usePostApiV5FilesPreferredFormat = <TError = PostApiV5FilesPreferredFormatErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5FilesPreferredFormat>>, TError,{data: PostApiV5FilesPreferredFormatBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiV5FilesPreferredFormat>>,
        TError,
        {data: PostApiV5FilesPreferredFormatBody},
        TContext
      > => {

      const mutationOptions = getPostApiV5FilesPreferredFormatMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Retrieves the preferred file naming format for the current CPA firm
 * @summary Get preferred file format for CPA
 */
export const getApiV5FilesPreferredFormat = (
    
 signal?: AbortSignal
) => {
      
      
      return getApiV5FilesPreferredFormatMutator<GetApiV5FilesPreferredFormat200>(
      {url: `/api/v5/files/preferred_format`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiV5FilesPreferredFormatQueryKey = () => {
    return [`/api/v5/files/preferred_format`] as const;
    }

    
export const getGetApiV5FilesPreferredFormatQueryOptions = <TData = Awaited<ReturnType<typeof getApiV5FilesPreferredFormat>>, TError = GetApiV5FilesPreferredFormatErrorType<GetApiV5FilesPreferredFormat404>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FilesPreferredFormat>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV5FilesPreferredFormatQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV5FilesPreferredFormat>>> = ({ signal }) => getApiV5FilesPreferredFormat(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV5FilesPreferredFormat>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV5FilesPreferredFormatQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV5FilesPreferredFormat>>>
export type GetApiV5FilesPreferredFormatQueryError = GetApiV5FilesPreferredFormatErrorType<GetApiV5FilesPreferredFormat404>


/**
 * @summary Get preferred file format for CPA
 */

export function useGetApiV5FilesPreferredFormat<TData = Awaited<ReturnType<typeof getApiV5FilesPreferredFormat>>, TError = GetApiV5FilesPreferredFormatErrorType<GetApiV5FilesPreferredFormat404>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FilesPreferredFormat>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV5FilesPreferredFormatQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns 3 file naming suggestions for a document, prioritizing CPA's saved format and popular industry formats
 * @summary Get file naming suggestions for a document
 */
export const getApiV5FilesIdNamingSuggestions = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return getApiV5FilesIdNamingSuggestionsMutator<GetApiV5FilesIdNamingSuggestions200>(
      {url: `/api/v5/files/${id}/naming_suggestions`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiV5FilesIdNamingSuggestionsQueryKey = (id: string,) => {
    return [`/api/v5/files/${id}/naming_suggestions`] as const;
    }

    
export const getGetApiV5FilesIdNamingSuggestionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV5FilesIdNamingSuggestions>>, TError = GetApiV5FilesIdNamingSuggestionsErrorType<GetApiV5FilesIdNamingSuggestions404>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FilesIdNamingSuggestions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV5FilesIdNamingSuggestionsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV5FilesIdNamingSuggestions>>> = ({ signal }) => getApiV5FilesIdNamingSuggestions(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV5FilesIdNamingSuggestions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV5FilesIdNamingSuggestionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV5FilesIdNamingSuggestions>>>
export type GetApiV5FilesIdNamingSuggestionsQueryError = GetApiV5FilesIdNamingSuggestionsErrorType<GetApiV5FilesIdNamingSuggestions404>


/**
 * @summary Get file naming suggestions for a document
 */

export function useGetApiV5FilesIdNamingSuggestions<TData = Awaited<ReturnType<typeof getApiV5FilesIdNamingSuggestions>>, TError = GetApiV5FilesIdNamingSuggestionsErrorType<GetApiV5FilesIdNamingSuggestions404>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FilesIdNamingSuggestions>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV5FilesIdNamingSuggestionsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns tag suggestions for a document based on its content and metadata
 * @summary Get tag suggestions for a document
 */
export const getApiV5FilesIdTagSuggestions = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return getApiV5FilesIdTagSuggestionsMutator<GetApiV5FilesIdTagSuggestions200>(
      {url: `/api/v5/files/${id}/tag_suggestions`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiV5FilesIdTagSuggestionsQueryKey = (id: string,) => {
    return [`/api/v5/files/${id}/tag_suggestions`] as const;
    }

    
export const getGetApiV5FilesIdTagSuggestionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV5FilesIdTagSuggestions>>, TError = GetApiV5FilesIdTagSuggestionsErrorType<GetApiV5FilesIdTagSuggestions404>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FilesIdTagSuggestions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV5FilesIdTagSuggestionsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV5FilesIdTagSuggestions>>> = ({ signal }) => getApiV5FilesIdTagSuggestions(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV5FilesIdTagSuggestions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV5FilesIdTagSuggestionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV5FilesIdTagSuggestions>>>
export type GetApiV5FilesIdTagSuggestionsQueryError = GetApiV5FilesIdTagSuggestionsErrorType<GetApiV5FilesIdTagSuggestions404>


/**
 * @summary Get tag suggestions for a document
 */

export function useGetApiV5FilesIdTagSuggestions<TData = Awaited<ReturnType<typeof getApiV5FilesIdTagSuggestions>>, TError = GetApiV5FilesIdTagSuggestionsErrorType<GetApiV5FilesIdTagSuggestions404>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FilesIdTagSuggestions>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV5FilesIdTagSuggestionsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Renames a document file with the provided filename
 * @summary Rename a document file
 */
export const putApiV5FilesIdRename = (
    id: string,
    putApiV5FilesIdRenameBody: PutApiV5FilesIdRenameBody,
 ) => {
      
      
      return putApiV5FilesIdRenameMutator<PutApiV5FilesIdRename200>(
      {url: `/api/v5/files/${id}/rename`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putApiV5FilesIdRenameBody
    },
      );
    }
  


export const getPutApiV5FilesIdRenameMutationOptions = <TError = PutApiV5FilesIdRenameErrorType<PutApiV5FilesIdRename404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV5FilesIdRename>>, TError,{id: string;data: PutApiV5FilesIdRenameBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV5FilesIdRename>>, TError,{id: string;data: PutApiV5FilesIdRenameBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV5FilesIdRename>>, {id: string;data: PutApiV5FilesIdRenameBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiV5FilesIdRename(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiV5FilesIdRenameMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV5FilesIdRename>>>
    export type PutApiV5FilesIdRenameMutationBody = PutApiV5FilesIdRenameBody
    export type PutApiV5FilesIdRenameMutationError = PutApiV5FilesIdRenameErrorType<PutApiV5FilesIdRename404>

    /**
 * @summary Rename a document file
 */
export const usePutApiV5FilesIdRename = <TError = PutApiV5FilesIdRenameErrorType<PutApiV5FilesIdRename404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV5FilesIdRename>>, TError,{id: string;data: PutApiV5FilesIdRenameBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof putApiV5FilesIdRename>>,
        TError,
        {id: string;data: PutApiV5FilesIdRenameBody},
        TContext
      > => {

      const mutationOptions = getPutApiV5FilesIdRenameMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Marks a document as reviewed by the current CPA user
 * @summary Mark document as reviewed
 */
export const putApiV5FilesIdMarkAsReviewed = (
    id: string,
 ) => {
      
      
      return putApiV5FilesIdMarkAsReviewedMutator<PutApiV5FilesIdMarkAsReviewed200>(
      {url: `/api/v5/files/${id}/mark_as_reviewed`, method: 'PUT'
    },
      );
    }
  


export const getPutApiV5FilesIdMarkAsReviewedMutationOptions = <TError = PutApiV5FilesIdMarkAsReviewedErrorType<PutApiV5FilesIdMarkAsReviewed404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV5FilesIdMarkAsReviewed>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV5FilesIdMarkAsReviewed>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV5FilesIdMarkAsReviewed>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  putApiV5FilesIdMarkAsReviewed(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiV5FilesIdMarkAsReviewedMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV5FilesIdMarkAsReviewed>>>
    
    export type PutApiV5FilesIdMarkAsReviewedMutationError = PutApiV5FilesIdMarkAsReviewedErrorType<PutApiV5FilesIdMarkAsReviewed404>

    /**
 * @summary Mark document as reviewed
 */
export const usePutApiV5FilesIdMarkAsReviewed = <TError = PutApiV5FilesIdMarkAsReviewedErrorType<PutApiV5FilesIdMarkAsReviewed404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV5FilesIdMarkAsReviewed>>, TError,{id: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof putApiV5FilesIdMarkAsReviewed>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPutApiV5FilesIdMarkAsReviewedMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns all documents uploaded by clients that are pending review for the current CPA
 * @summary Get documents pending review
 */
export const getApiV5FilesPendingReview = (
    
 signal?: AbortSignal
) => {
      
      
      return getApiV5FilesPendingReviewMutator<GetApiV5FilesPendingReview200>(
      {url: `/api/v5/files/pending_review`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiV5FilesPendingReviewQueryKey = () => {
    return [`/api/v5/files/pending_review`] as const;
    }

    
export const getGetApiV5FilesPendingReviewQueryOptions = <TData = Awaited<ReturnType<typeof getApiV5FilesPendingReview>>, TError = GetApiV5FilesPendingReviewErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FilesPendingReview>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV5FilesPendingReviewQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV5FilesPendingReview>>> = ({ signal }) => getApiV5FilesPendingReview(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV5FilesPendingReview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV5FilesPendingReviewQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV5FilesPendingReview>>>
export type GetApiV5FilesPendingReviewQueryError = GetApiV5FilesPendingReviewErrorType<unknown>


/**
 * @summary Get documents pending review
 */

export function useGetApiV5FilesPendingReview<TData = Awaited<ReturnType<typeof getApiV5FilesPendingReview>>, TError = GetApiV5FilesPendingReviewErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FilesPendingReview>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV5FilesPendingReviewQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Updates the tags for a document with the provided array of tags
 * @summary Update tags for a document
 */
export const putApiV5FilesIdUpdateTags = (
    id: string,
    putApiV5FilesIdUpdateTagsBody: PutApiV5FilesIdUpdateTagsBody,
 ) => {
      
      
      return putApiV5FilesIdUpdateTagsMutator<PutApiV5FilesIdUpdateTags200>(
      {url: `/api/v5/files/${id}/update_tags`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putApiV5FilesIdUpdateTagsBody
    },
      );
    }
  


export const getPutApiV5FilesIdUpdateTagsMutationOptions = <TError = PutApiV5FilesIdUpdateTagsErrorType<PutApiV5FilesIdUpdateTags400 | PutApiV5FilesIdUpdateTags404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV5FilesIdUpdateTags>>, TError,{id: string;data: PutApiV5FilesIdUpdateTagsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV5FilesIdUpdateTags>>, TError,{id: string;data: PutApiV5FilesIdUpdateTagsBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV5FilesIdUpdateTags>>, {id: string;data: PutApiV5FilesIdUpdateTagsBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiV5FilesIdUpdateTags(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiV5FilesIdUpdateTagsMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV5FilesIdUpdateTags>>>
    export type PutApiV5FilesIdUpdateTagsMutationBody = PutApiV5FilesIdUpdateTagsBody
    export type PutApiV5FilesIdUpdateTagsMutationError = PutApiV5FilesIdUpdateTagsErrorType<PutApiV5FilesIdUpdateTags400 | PutApiV5FilesIdUpdateTags404>

    /**
 * @summary Update tags for a document
 */
export const usePutApiV5FilesIdUpdateTags = <TError = PutApiV5FilesIdUpdateTagsErrorType<PutApiV5FilesIdUpdateTags400 | PutApiV5FilesIdUpdateTags404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV5FilesIdUpdateTags>>, TError,{id: string;data: PutApiV5FilesIdUpdateTagsBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof putApiV5FilesIdUpdateTags>>,
        TError,
        {id: string;data: PutApiV5FilesIdUpdateTagsBody},
        TContext
      > => {

      const mutationOptions = getPutApiV5FilesIdUpdateTagsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    